import {
	createSlice,
	current
} from '@reduxjs/toolkit';
import {
	getResidueCategoryList,
	addNewResidueCategory,
	updateResidueCategory,
	deleteResidueCategory,
	getResidueCategory,
} from '../residueCategory/thunk';

export const initialState = {
	itemResidueCategoryList: [],
	itemResidueCategoryDetail: null,
	isResidueCategoryLoading: false,
	isResidueCategorySuccess: false,

	residueCategoryList: [],
	residueCategoryListSelect: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,
};

const ResidueCategorySlice = createSlice({
	name: 'ResidueCategories',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
	},
	extraReducers: builder => {
		builder.addCase(getResidueCategory.fulfilled, (state, action) => {
			state.isResidueCategoryLoading = false;
			state.isResidueCategorySuccess = true;
			state.itemResidueCategoryDetail = action.payload;
			state.isLoadingList = false;
		});
		builder.addCase(getResidueCategory.pending, state => {
			state.isResidueCategoryLoading = true;
			state.isResidueCategorySuccess = null;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getResidueCategory.rejected, (state, action) => {
			state.isResidueCategoryLoading = false;
			state.isResidueCategorySuccess = false;
			state.error = action.error.message;
			state.isLoadingList = false;
		});

		builder.addCase(getResidueCategoryList.pending, state => {
			state.isResidueCategorySuccess = true;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getResidueCategoryList.fulfilled, (state, action) => {
			state.itemResidueCategoryList = action.payload;
			state.residueCategoryList = action.payload;
			state.isLoadingList = false;
			state.isResidueCategorySuccess = true;

			let residueCategoryListSelect = [];
			action.payload.map(item =>
				residueCategoryListSelect.push({
					item: item,
					value: item._id,
					label: item.name,
				})
			);

			state.residueCategoryListSelect = residueCategoryListSelect;
		});
		builder.addCase(getResidueCategoryList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isResidueCategorySuccess = true;
		});
		builder.addCase(addNewResidueCategory.fulfilled, (state, action) => {
			state.itemResidueCategoryList.push(action.payload);
			state.residueCategoryList.push(action.payload);
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.isAddError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(addNewResidueCategory.pending, (state, action) => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});
		builder.addCase(addNewResidueCategory.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = false;
			state.isAddError = true;
		});

		builder.addCase(updateResidueCategory.fulfilled, (state, action) => {
			state.itemResidueCategoryList = state.itemResidueCategoryList.map(residueCategory =>
				residueCategory.residueCategoryname === action.payload.old_residueCategory
					? { ...residueCategory, ...action.payload.updated_residueCategory }
					: residueCategory
			);
			state.residueCategoryList = state.residueCategoryList.map(residueCategory =>
				residueCategory._id.toString() === action.payload._id.toString()
					? { ...residueCategory, ...action.payload }
					: residueCategory
			);
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = true;
			state.isUpdateError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(updateResidueCategory.pending, state => {
			state.isLoadingList = true;
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});
		builder.addCase(updateResidueCategory.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = false;
			state.isUpdateError = true;
		});

		builder.addCase(deleteResidueCategory.fulfilled, (state, action) => {
			state.itemResidueCategoryList = current(state.itemResidueCategoryList).filter(
				item => item._id !== action.payload._id
			);
			state.residueCategoryList = current(state.residueCategoryList).filter(item =>
				item._id !== action.payload._id
			);
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
			state.requireCloseModal = true;
		});
		builder.addCase(deleteResidueCategory.pending, (state, action) => {
			state.isLoadingList = true;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
		});
		builder.addCase(deleteResidueCategory.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = false;
			state.isDelete = true;
		});
	},
});

export const { setRequireCloseModal } = ResidueCategorySlice.actions;

export default ResidueCategorySlice.reducer;
